// App catalogue with hourly rates (EUR / hour) and estimated savings per operational hour
export const APPS = [
  { id: "gestionale", rate: 2.5, saves: 6, color: "#00E5FF" },
  { id: "team", rate: 2.0, saves: 5, color: "#80F2FF" },
  { id: "kitchen", rate: 3.0, saves: 8, color: "#FF5A36" },
  { id: "bar", rate: 3.0, saves: 5, color: "#FF8A70" },
];

export const WEEKS_PER_MONTH = 4.33;

export function appRate(id) {
  const a = APPS.find((x) => x.id === id);
  return a ? a.rate : 0;
}

export function computeCost(selectedIds, hoursPerDay, daysPerWeek) {
  const hourlySum = selectedIds.reduce((sum, id) => sum + appRate(id), 0);
  const weekly = hourlySum * hoursPerDay * daysPerWeek;
  const monthly = weekly * WEEKS_PER_MONTH;
  return {
    hourlySum,
    weekly: Math.round(weekly * 100) / 100,
    monthly: Math.round(monthly * 100) / 100,
  };
}

// Estimated monthly savings based on monthly operational hours
export function computeSavings(selectedIds, hoursPerDay, daysPerWeek) {
  const savesSum = selectedIds.reduce(
    (sum, id) => sum + (APPS.find((a) => a.id === id)?.saves || 0),
    0
  );
  const monthlyHours = hoursPerDay * daysPerWeek * WEEKS_PER_MONTH;
  const monthlySavings = savesSum * monthlyHours;
  return {
    monthlyHours: Math.round(monthlyHours),
    monthlySavings: Math.round(monthlySavings * 100) / 100,
  };
}

export const PLANS = [
  { id: "starter", apps: ["gestionale"], accent: "#00E5FF", popular: false },
  { id: "team", apps: ["gestionale", "team"], accent: "#80F2FF", popular: false },
  { id: "kitchen", apps: ["gestionale", "team", "kitchen"], accent: "#FF5A36", popular: true },
  { id: "full", apps: ["gestionale", "team", "kitchen", "bar"], accent: "#FF8A70", popular: false },
];
